import { render, staticRenderFns } from "./logo-header.vue?vue&type=template&id=771ccc1c&"
import script from "./logo-header.vue?vue&type=script&lang=js&"
export * from "./logo-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports